import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';
import NavActions from '../../actions';
import { getDataAttribute } from 'epic-common/src/browser';
import { UserIcon } from '../';

@pureRender
export default class SignedIn extends React.Component {
    static propTypes = {
        displayName: PropTypes.string,
        isActive: PropTypes.bool,
        signOutLink: PropTypes.object,
        dropdownLinks: PropTypes.array,
        hideCallToAction: PropTypes.bool
    };

    static contextTypes = {
        isMobile: PropTypes.bool,
        messages: PropTypes.object,
        globalLinkOnClick: PropTypes.func
    };

    onSignOutClick = (e) => {
        const signOutLink = this.props.signOutLink || {};
        const href = signOutLink.href;

        let globalReturnValue = null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            globalReturnValue = this.context.globalLinkOnClick(e, href);
        }

        if (globalReturnValue !== false) {
            if (signOutLink && signOutLink.onClick && typeof signOutLink.onClick === 'function') {
                signOutLink.onClick(e);
            }
        }

        NavActions.closeMobileTablet.defer();
    };

    onDropdownClick = (e) => {
        const index = +getDataAttribute(e.currentTarget, 'index');
        const link = this.props.dropdownLinks[index];
        const href = link.href;
        let globalReturnValue = null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            globalReturnValue = this.context.globalLinkOnClick(e, href);
        }

        if (globalReturnValue !== false) {
            if (link && link.onClick && typeof link.onClick === 'function') {
                link.onClick(e);
            }
        }

        NavActions.closeMobileTablet.defer();
    };

    close = () => {
        NavActions.mobileUserActive(false);
        NavActions.mobileNavActiveLinks(true);
    };

    render() {
        const messages = this.context.messages || {};
        const username = this.props.displayName || messages.default_username;
        const dropdownLinks = this.props.dropdownLinks || [];
        const signOutLink = this.props.signOutLink || {};

        return (
            <div
                id="user"
                className={`signed-in loggedIn ${this.context.isMobile ? 'rightnav-bg-color' : 'bg-color dropdown'} ${this.props.isActive ? 'active' : ''}`}>
                {!this.context.isMobile ?
                    <UserIcon
                        mobileUserActive={this.props.isActive}
                        isLoggedIn={true}
                        username={username} /> : ''}

                <ul className={`${this.context.isMobile ? 'mobile-list' : 'bg-color'} ${this.props.hideCallToAction ? 'ul-right' : 'ul-left'}`}>
                    {this.context.isMobile ? <li
                        role="menuitem"
                        className={`${this.context.isMobile ? 'mobile-heading' : ''}`}
                        onClick={this.close}>
                        <a className={`${!this.context.isMobile ? 'username' : ''}`}>
                            <span>{username}</span>
                        </a>
                    </li> : ''}
                    {
                        dropdownLinks.map((link, i) => {
                            if (link && link.title) {
                                const key = link.key ? `dropdown-link-${link.key}` : `dropdown-link-${link.title}`;
                                return (
                                    <li className={`${this.context.isMobile ? 'mobile-list-item' : ''}`} key={key}>
                                        <a
                                            className="text-color-hover text-color-nonactive"
                                            href={link.href || '#'}
                                            id={key}
                                            data-index={i}
                                            onClick={this.onDropdownClick}><span>{link.title}</span></a>
                                    </li>
                                );
                            }
                            return undefined;
                        })
                    }
                    <li className={`${this.context.isMobile ? 'mobile-list-item' : ''}`}>
                        <a
                            className="text-color-hover text-color-nonactive"
                            href={signOutLink.href || '#'}
                            id="log-out"
                            onClick={this.onSignOutClick}>
                            <span>{messages.sign_out}</span>
                        </a>
                    </li>
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/scripts/components/signedIn/SignedIn.js